import { Typography } from '@prenuvo/halo';

import { CwfActiveDocument, CwfDocumentTypeName } from '@/api';

import { CWF_DOCS_TYPE_NAME_MAP } from '../../../../../constant';
import { generateCwfDocumentLink } from '../patient-docs.util';
import { usePatientDocs } from '../use-patient-docs.hook';
import { DocumentActions } from './document-actions.component';
import { DocumentRowContainer } from './document-row-container.component';

interface DocumentRowProps {
  document: CwfActiveDocument;
}

export function DocumentRow({ document }: DocumentRowProps) {
  const { onUpdatePatientDocument, types } = usePatientDocs();

  const name = types.find(({ uuid }) => uuid === document.typeId)?.name;

  const link =
    document.studyId || (document.careActivityId && document.carePlanId)
      ? generateCwfDocumentLink(document)
      : undefined;

  const handleOpenDocument = () => {
    if (link) {
      onUpdatePatientDocument({
        link,
        name: name as CwfDocumentTypeName,
      });
    }
  };

  return (
    <DocumentRowContainer>
      <Typography
        translationKey={
          name
            ? CWF_DOCS_TYPE_NAME_MAP[name as CwfDocumentTypeName]
            : 'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.UNKNOWN'
        }
        variant="paragraph-sm"
      />

      {link && <DocumentActions link={link} onOpenDocument={handleOpenDocument} />}
    </DocumentRowContainer>
  );
}
